var map = {
	"./Favorites": 1105,
	"./Favorites.tsx": 1105,
	"./FavoritesDeferred": 349,
	"./FavoritesDeferred.tsx": 349,
	"./FavoritesPage": 348,
	"./FavoritesPage.dictionary": 332,
	"./FavoritesPage.dictionary.json": 332,
	"./FavoritesPage.explanation": 1106,
	"./FavoritesPage.explanation.ts": 1106,
	"./FavoritesPage.tsx": 348,
	"./actions": 102,
	"./actions/": 102,
	"./actions/index": 102,
	"./actions/index.ts": 102,
	"./components/Loader": 1001,
	"./components/Loader/": 1001,
	"./components/Loader/Loader": 952,
	"./components/Loader/Loader.dictionary": 918,
	"./components/Loader/Loader.dictionary.json": 918,
	"./components/Loader/Loader.explanation": 1107,
	"./components/Loader/Loader.explanation.ts": 1107,
	"./components/Loader/Loader.module.scss": 1013,
	"./components/Loader/Loader.tsx": 952,
	"./components/Loader/index": 1001,
	"./components/Loader/index.ts": 1001,
	"./components/NoData": 1002,
	"./components/NoData/": 1002,
	"./components/NoData/NoData": 953,
	"./components/NoData/NoData.dictionary": 921,
	"./components/NoData/NoData.dictionary.json": 921,
	"./components/NoData/NoData.explanation": 1108,
	"./components/NoData/NoData.explanation.ts": 1108,
	"./components/NoData/NoData.module.scss": 1014,
	"./components/NoData/NoData.tsx": 953,
	"./components/NoData/index": 1002,
	"./components/NoData/index.ts": 1002,
	"./components/NoDataSkeleton": 886,
	"./components/NoDataSkeleton/": 886,
	"./components/NoDataSkeleton/NoDataSkeleton": 868,
	"./components/NoDataSkeleton/NoDataSkeleton.module.scss": 919,
	"./components/NoDataSkeleton/NoDataSkeleton.tsx": 868,
	"./components/NoDataSkeleton/constants": 887,
	"./components/NoDataSkeleton/constants.ts": 887,
	"./components/NoDataSkeleton/index": 886,
	"./components/NoDataSkeleton/index.ts": 886,
	"./components/PopularMatches": 888,
	"./components/PopularMatches/": 888,
	"./components/PopularMatches/PopularMatches": 869,
	"./components/PopularMatches/PopularMatches.dictionary": 871,
	"./components/PopularMatches/PopularMatches.dictionary.json": 871,
	"./components/PopularMatches/PopularMatches.explanation": 1109,
	"./components/PopularMatches/PopularMatches.explanation.ts": 1109,
	"./components/PopularMatches/PopularMatches.module.scss": 920,
	"./components/PopularMatches/PopularMatches.tsx": 869,
	"./components/PopularMatches/index": 888,
	"./components/PopularMatches/index.ts": 888,
	"./components/SportGrid": 855,
	"./components/SportGrid/": 855,
	"./components/SportGrid/SportGrid": 840,
	"./components/SportGrid/SportGrid.module.scss": 870,
	"./components/SportGrid/SportGrid.tsx": 840,
	"./components/SportGrid/index": 855,
	"./components/SportGrid/index.ts": 855,
	"./components/TournamentTable": 841,
	"./components/TournamentTable/": 841,
	"./components/TournamentTable/TournamentTable": 832,
	"./components/TournamentTable/TournamentTable.ts": 832,
	"./components/TournamentTable/index": 841,
	"./components/TournamentTable/index.ts": 841,
	"./reducer": 294,
	"./reducer/": 294,
	"./reducer/entities": 366,
	"./reducer/entities.ts": 366,
	"./reducer/index": 294,
	"./reducer/index.js": 294,
	"./reducer/presentation": 367,
	"./reducer/presentation.ts": 367,
	"./selectors/gridEntities": 125,
	"./selectors/gridEntities.ts": 125,
	"./selectors/gridPresentation": 1056,
	"./selectors/gridPresentation.ts": 1056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1236;
module.exports = webpackContext;